module.exports = __webpack_public_path__ + "img/solution2_banner.dfeb8809.png";